<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3 v-if="editMemo.id">{{'Vorgabe bearbeiten'}}</h3>
              <h3 v-else>{{'Neue Vorgabe anlegen'}}</h3>
               
               
              <div v-if="false">
                <!-- DEBUGG -->
                idCompany: {{editMemo.idCompany}}
                idUser: {{editMemo.idUserClient}}
              </div>
              
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form @keyup.esc="$emit('cancel', memo)" @submit.prevent="onSubmit"  :id="_uid">

                <div class="form-group">
                  <label for="memo-type">Art :</label>
                  <select required id="memo-type" class="form-control text-right" v-model="editMemo.typ">
                    <option v-for="option in MemoConf.TYP"
                      v-bind:value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                                

                <div class="form-group">
                  <label for="memo-headline">Überschrift:</label>
                  <input  v-focus required 
                    type="text" 
                    class="form-control" 
                    id="memo-headline" 
                    placeholder="Überschrift..." 
                    v-model="editMemo.headline">
                </div>
                
                <div class="form-group">
                  <label for="memo-summary">Zusammenfassung:</label>
                  <input type="text" class="form-control" id="memo-summary" placeholder="Zusammenfassung..." v-model="editMemo.summary">
                </div>
                
                <!-- @see also https://github.com/maxwells/bootstrap-tags -->
              <!-- Vertreter -->
               
                <div class="form-group">
                  <label for="memo-proxy">Vertreter:</label>
                  <div  style="margin-bottom: 15px" v-for="userClient in editMemo.userClientRef" >
                    <span class="tag label label-default">
                      <span>
                        {{userClient.firstName}} {{userClient.lastName}} {{userClient.department}} {{userClient.room}} {{userClient.function}}
                      </span>
                      <a>
                        <i 
                        @click="onRemoveAbsence(userClient)"  
                        class="remove glyphicon glyphicon-remove-sign glyphicon-white" 
                        title="Vertreter entfernen">
                        </i>
                      </a>
                    </span>
                  </div>
                </div>                

              <user-client-typeahead v-if="0" style="margin-bottom:15px;" @onHit="onAddAbsence"></user-client-typeahead>
              <!-- END Vertreter -->
                
                <div class="form-group">
                  <label style="padding-bottom: 12px" for="memo-text">Beschreibung:</label>
                  
                  <button type="button" class="btn btn-primary btn-sm" style="margin-left: 5em"
                    v-if="preview"
                    title="Vorschau"
                    @click="preview = !preview"
                    >
                    <i class="fa fa-edit"></i>Bearbeiten
                  </button>        

                  <button type="button" class="btn btn-primary btn-sm" style=" margin-left: 5em"
                    v-else
                    title="Beschreibung berabeiten"
                    @click="preview = !preview"
                    >
                    <i class="fa fa-eye"></i>Vorschau
                  </button>        

                 <span v-if="!preview"> 
                  <button type="button" class="btn btn-link" style="color: red;"
                    title="Formatiere als 'wichtig'"
                    @click="onStyleWichtig"
                    >
                    wichtig
                  </button>        
                  <button type="button" class="btn btn-link"
                    title="vom Auftraggeber gewünscht"
                    @click="onStyleDaten"
                    >
                    <span style="color: black; background-color: yellow">Daten</span>
                  </button>        

                  <button type="button" class="btn btn-link" 
                    title="Textvorschlag im Gespräch"
                    @click="onStyleText"
                    >
                    <span style="background-color: lightgreen"> &gt;&gt;&gt; </span>
                    <span style="color: black">wörtlich</span>
                    <span style="color: black; background-color: lightgreen"> &lt;&lt;&lt; </span>
                  </button>        

                  <button type="button" class="btn btn-link"
                    title="Formatiere als 'Überschrift'"
                    @click="onStyleBlod"
                    >
                    <b style="color: black">Überschrift</b>
                  </button>        

                   <textarea class="form-control" id="memo-text" rows="6" placeholder="Beschreibung ..."  v-model="editMemo.text"></textarea>
                  </span>
                  <div v-if="preview" style="border: 1px solid lightgrey; padding:10px"  v-html="text2html()"></div>
                </div>
                


                <div class="form-group">
                  <label for="memo-type">Ansicht der Beschreibung:</label>
                  <select id="memo-view" class="form-control text-right" v-model="editMemo.view">
                    <option v-for="option in MemoView.TYP"
                      v-bind:value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                
                 <div class="form-group">
                  <label for="memo-datetime-begin">Beginn :</label>
                  <cc-datetime label_id="memo-datetime-begin" v-model="editMemo.datetimeBegin"></cc-datetime>
                </div>
                
                <div class="form-group">
                  <label for="memo-datetime-end">Ende :</label>
                  <cc-datetime label_id="memo-datetime-end" v-model="editMemo.datetimeEnd"></cc-datetime>
                </div>                
                
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="submit"
                :form="_uid"
                class="btn btn-primary">
                Speichern
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('cancel', memo)">
                Abbrechen
              </button>

              <button type="" 
                v-if="editMemo.id" 
                class="btn btn-danger"   
                @click="$emit('remove', memo)">
                Löschen
              </button>               
               
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import MemoCommon from './common/memo.common'
import DateTime from './helper/datetime.vue'
import UserClientTypeahead from './UserClientTypeahead.vue'


export default {
  
  extends: MemoCommon,
  
  components: {
    'cc-datetime': DateTime,
    'user-client-typeahead': UserClientTypeahead,
  },  

  
  data () {
    return {
      editMemo: JSON.parse(JSON.stringify(this.memo)), 
      preview: false
    }
  },
  
  created: function () {
  },
  
  computed: {
  },  
  
  
  methods: {
    
    text2html: function () {
      
      //nl2br
      var htmlText = this.editMemo.text.replace(/(\r\n|\n\r|\r|\n)/g, "<br>")
      
      //style
      var search = /{style::([a-z-]+:[a-z-]+)::([^}]+)}/g;
      var replace = '<span style="$1">$2</span>';
      htmlText = htmlText.replace(search, replace);
      
      //intern
      search = /{intern::[0-9]+::([^}]+)}/g;
      var replace = '<a style="color:purple; text-decoration: underline;">$1</a>';
      htmlText = htmlText.replace(search, replace);
    
      return htmlText
      
    },
    
    
    onStyleWichtig: function () {
      let splitedText =  this.splitMemoText("Wichtig")
      this.editMemo.text = splitedText.leftText + "{style::color:red::" + splitedText.markedText + "}" + splitedText.rightText
    },

    onStyleDaten: function () {
      let splitedText =  this.splitMemoText("Daten")
      this.editMemo.text = splitedText.leftText + "{style::background-color:yellow::" + splitedText.markedText + "}" + splitedText.rightText
    },

    onStyleText: function () {
      let splitedText =  this.splitMemoText("Wörtlich")
      this.editMemo.text = splitedText.leftText + "{style::background:lightgreen::>>>}" + splitedText.markedText + "{style::background:lightgreen::<<<}" + splitedText.rightText
    },
    
    onStyleBlod: function () {
      let splitedText =  this.splitMemoText("Überschrift")
      this.editMemo.text = splitedText.leftText + "{style::font-weight:bold::" + splitedText.markedText + "}\n" + splitedText.rightText
    },

    splitMemoText: function (defaultText) {
      let start = $('#memo-text').prop("selectionStart")
      let end = $('#memo-text').prop("selectionEnd")
      let text = this.editMemo.text
      let leftText = text.substring(0, start)
      let rightText = text.substring(end)
      let markedText = text.substring(start, end)
      
      if (markedText.length == 0){
        markedText = defaultText
      }
      
      return {
        leftText: leftText,
        rightText: rightText,
        markedText: markedText,
        }
      
    },
    
    onAddAbsence: function (item) {
      this.editMemo.userClientRef.push(item);
    },

    onRemoveAbsence: function (item) {
      this.editMemo.userClientRef.splice(this.editMemo.userClientRef.indexOf(item.id), 1);
      console.log('onRemoveAbsence'+ item.id);
    },

    

    onSubmit: function () {
      if(_.isEqual(this.memo, this.editMemo)){
        // keine Änderung, speichern nicht notwendig
        this.$emit('cancel', this.memo)
      }else{
        // speichern
        this.$emit('save', this.editMemo)
      }
    },
    
  },
}
  
</script>

<style scoped>
  
  
.tag {
  font-size: 14px;
  padding: .3em .4em .4em;
  margin: 0 .1em;
}
.tag a {
  color: #bbb;
  cursor: pointer;
  opacity: 0.6;
}
.tag a:hover {
  opacity: 1.0
}
.tag .remove {
  vertical-align: bottom;
  top: 0;
}
.tag a {
  margin: 0 0 0 .3em;
}
.tag a .glyphicon-white {
  color: #fff;
  margin-bottom: 2px;
} 
  .label-default{
    background-color: #bbb;    
  }  
  
  

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80vh;
  /*margin: 0px auto;*/
  margin-left: 15%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  height:50vh;
  margin: 20px 0;
  padding-bottom: 50px;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  
input:invalid {
  border: 1px solid red;
}  
</style>



// WEBPACK FOOTER //
// MemoModal.vue?72fc1cee